import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "openIcon", "closeIcon"]

  connect() {
    this.onScroll = this.handleScroll.bind(this)
    window.addEventListener("scroll", this.onScroll)
    this.handleScroll()
    this.isMenuOpen = false
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    this.enableBodyScroll()
  }

  handleScroll() {
    const isTransparent = this.element.dataset.transparent === "true"

    if (isTransparent && window.scrollY <= 50) {
      this.element.classList.add("is-transparent")
      this.element.classList.remove("bg-white", "shadow-md")
    } else {
      this.element.classList.remove("is-transparent")
      this.element.classList.add("bg-white", "shadow-md")
    }
  }

  toggle() {
    this.isMenuOpen ? this.close() : this.open()
  }

  open() {
    const headerHeight = this.element.getBoundingClientRect().height
    this.menuTarget.style.top = `${headerHeight}px`
    this.menuTarget.classList.remove("hidden")
    this.openIconTarget.classList.add("hidden")
    this.closeIconTarget.classList.remove("hidden")
    this.isMenuOpen = true
    this.disableBodyScroll()
    setTimeout(() => this.menuTarget.classList.add("animate-slide-in-down"), 10)
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.menuTarget.classList.remove("animate-slide-in-down")
    this.openIconTarget.classList.remove("hidden")
    this.closeIconTarget.classList.add("hidden")
    this.isMenuOpen = false
    this.enableBodyScroll()
  }

  disableBodyScroll() {
    document.body.style.overflow = "hidden"
  }

  enableBodyScroll() {
    document.body.style.overflow = ""
  }
}
